import React from 'react';
import cn from 'classnames';
import styles from './style.scss';
import ZoomLogo from '../../../static/zoom-logo.png';

function Host({ event, settings, className = '' }) {
  if (!event.has('host') || !settings.get('showZoomHostInfo')) {
    return <span />;
  }

  const text = event.hasIn(['host', 'company'])
    ? event.getIn(['host', 'company'])
    : `${event.getIn(['host', 'first_name'], '')} ${event.getIn(['host', 'last_name'], '')}`;
  return (
    <div className={cn('host', styles.hostContainer, className)}>
      <img src={ZoomLogo} alt="zoom" width={30} />

      <div>
        <div className={cn(styles.hostText, 'host-text')}>{settings.get('hostText')}</div>
        <div className={cn(styles.hostEmail, 'host-email')}>{text}</div>
      </div>
    </div>
  );
}

export default Host;
